<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import type { LinkComponentButtonProps } from './types';

  type $$Props = LinkComponentButtonProps;
  export let nofollow: $$Props['nofollow'] = undefined;
  export let target: $$Props['target'] = undefined;
  export let text: $$Props['text'];
  export let url: $$Props['url'];
  export let modal: $$Props['modal'] = undefined;

  export let variant: 'button' | 'button-alt' = 'button';

  const dispatch = createEventDispatcher();

  function handleOnClick(event: Event) {
    if (modal) {
      event.preventDefault();
      dispatch('open-modal');
    }
  }
</script>

<a class={`LinkComponent--${variant}`} href={url} {target} rel={nofollow} on:click={handleOnClick}>
  {text}
</a>

<style lang="scss">
  @use '@squareup/public-web-design-system/dist/styles/xms-fe/mixins/ui.scss' as ui;
  @layer standard-components {
    .LinkComponent--button {
      @include ui.button;
    }
    .LinkComponent--button-alt {
      @include ui.button('alt');
    }
  }
</style>
